import { ChoiceTileOption } from "components/ui/choice-tiles";

export type WellSkyAuthMethod = "usernamePassword" | "apiKey";

export const wellSkyAuthMethodOptions: ChoiceTileOption<WellSkyAuthMethod>[] = [
    {
        key: "usernamePassword",
        title: "Username and password",
        description: "A WellSky Personal Care sign-in",
    },
    {
        key: "apiKey",
        title: "API key",
        description: "WellSky Connect API credentials",
    },
];
